import styles from './HomePrayerScene.module.css';

interface HomePrayerSceneProps {
  // Listening or writing: brighten the whole scene (the dawn-breaking
  // recording cue).
  active: boolean;
  // A prayer was just saved: a brief warm glow surge over the scene.
  saved: boolean;
  // There is prayer text present (typing or voice STT): cross-fade in a
  // green-darkened copy of the scene so the foliage mutes and the prayer
  // text reading over the canopy stays legible. The empty/contemplative
  // state keeps the tree at full brightness.
  hasText: boolean;
}

// Home prayer atmosphere: a tree-by-stream scene that sits behind every chrome
// element (z-index -1, pointer-events none) so the prayer text floats in the
// dark sky above it and the mic reads as the glowing point of light at the
// waterline. The photo is a CSS cover background on .scene (device-swapped by
// media query): full-screen on mobile, full-bleed behind the centered prayer
// column on desktop (see the .module.css @media). The scrim / vignette / glow
// layers stack on top. The recording brighten and the save surge are
// opacity-driven (no filter, no video, no perpetual animation), so no animated
// GPU layer composites under a modal.
export default function HomePrayerScene({ active, saved, hasText }: HomePrayerSceneProps) {
  const cls = [
    styles.scene,
    active ? styles.active : '',
    saved ? styles.saved : '',
    hasText ? styles.hasText : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cls} aria-hidden="true">
      {/* Photo is the .scene background (device-swapped in the .module.css).
          No top fade — the image reads continuous to the top edge; the empty-
          state guidance text is raised into the dark sky above the tree. */}
      {/* Green-darkened copy of the scene, cross-faded in only when there is
          prayer text (hasText), to mute the foliage for legibility. Same
          image, only the lit-green pixels differ, so the fade reads as the
          leaves dimming. Below the vignette/glow so those still layer on top. */}
      <div className={styles.sceneDim} />
      {/* Dark pool behind the mic so the bright water reflection recedes and
          the mic floats over the scene. Painted below the glow so the recording
          dawn-bloom still overrides it. Static. */}
      <div className={styles.vignette} />
      <div className={styles.glow} />
    </div>
  );
}
